import React, { useEffect, useState } from 'react'
import { FormProvider, SubmitHandler, UseFormReturn } from 'react-hook-form'
import Tenant from '../../../shared/models/tenant'
import { Button, Col, Form, Row } from 'react-bootstrap'
import ContactBasedForm from '../../common/form/ContactBasedForm'

interface TenantFormProps {
  form: UseFormReturn<Tenant>
  onSubmit: SubmitHandler<Tenant>
  initialValues?: Partial<Tenant>
  isLoading?: boolean
}

const TenantForm = ({
  form,
  onSubmit,
  initialValues,
  isLoading,
}: TenantFormProps) => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = form

  // Init value if needed
  useEffect(() => {
    reset(initialValues)
  }, [initialValues])

  return (
    <FormProvider {...form}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Col md={'6'}>
            <Form.Label htmlFor="name">Name</Form.Label>
            <Form.Control
              className="mb-2"
              disabled={isLoading}
              type="text"
              placeholder="Enter the name"
              isInvalid={!!errors.name}
              {...register('name', { required: 'Name field is required' })}
            />
            <Form.Control.Feedback type="invalid">
              {errors.name && errors.name.message}
            </Form.Control.Feedback>
          </Col>
          <Col md={'6'}>
            <Form.Label htmlFor="description">Description</Form.Label>
            <Form.Control
              disabled={isLoading}
              type="text"
              className="mb-2"
              placeholder="Description of the profile"
              isInvalid={!!errors.description}
              {...register('description', {
                required: 'Description field is required',
              })}
            />
            <Form.Control.Feedback type="invalid">
              {errors.description && errors.description.message}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row className={'gx-3 gy-2 align-items-center'}>
          <Col md={'6'}>
            <Form.Label htmlFor="tenantProfileId">Profile</Form.Label>

          </Col>
        </Row>
        <Row className={'gx-3 gy-2 align-items-center mt-3'}>
          <Col md={12}>
            <h3>Adresse et contact</h3>
          </Col>
        </Row>
        <ContactBasedForm errors={errors} />
        <Button type={'submit'}>Submit</Button>
      </Form>
    </FormProvider>
  )
}

export default TenantForm
